import { CHART_TYPES } from '../components/charts/constants';

export const ContractFilterOrder = [
  'JobTitle',
  'JobTitleEquivalentCategory',
  'ManagerNames',
  'ManagerFlag',
  'ContractType',
  'EmployeeStatus',
  'StartDate',
  'EmployeesTenure',
  'RecruitmentReason',
  'TerminationCause',
  'Termination',
  'TerminationCauseVoluntary',
];

export const EmployeesFilterOrder = [
  'Gender',
  'Date_of_birth',
  'EmployeesAge',
  'MaritalStatus',
  'Nationality',
  'EmployeeIdRemote',
  'EmployeesCity',
  'EmployeesCountry',
];

export const OrganizationFilterOrder = [
  'CompanyName',
  'Entities',
  'Department',
  'CompanyCity',
  'CompanyCountry',
];

export const fileFormat = {
  CSV: 'CSV',
  EXCEL: 'Excel',
  PDF: 'PDF',
};

export const FileExtensionMapping = {
  Excel: 'xlsx',
  CSV: 'csv',
  default: 'csv',
};
export const trainingCostMetrics = ['TotalTrainingCost', 'TrainingSalaryCost', 'TrainingCost'];

export const oneDecimalSubMetric = new Set([]);

export const filtersToIgnoreSort = new Set(['EmployeesTenure']);

export const filtersWithCapitalizedOptions = new Set([
  'CompanyName',
  'ManagerNames',
  'TrainingName',
]);

export const SUPER_ADMIN_DOMAIN = 'Super Admin Domain';
export const SUPER_ADMIN_ROLE_ID = 1;

export const DashboardRoles = {
  Viewer: 'Viewer',
  Editor: 'Editor',
  Owner: 'Owner',
};

export const SHARE_MODES = {
  Share: 'share',
  Publish: 'publish',
};

export const DASHBOARD_OPTIONS = [
  { id: 'existing', label: 'Existing dashboard', value: 'existing' },
  { id: 'new', label: 'New dashboard', value: 'new' },
];

export const filtersCategories = {
  Organization: 'Organization',
  Employees: 'Employees',
  Contract: 'Contract',
  PayrollAnalytics: 'payrollAnalytics',
  PayrollLines: 'PayrollLines',
  Recruitment: 'Recruitment',
  Training: 'Training',
  Compensation: 'Compensation',
  Absence: 'Absence',
};

export const TableCharts = ['AdvancedTable', 'DataGrid', 'Table'];

export const NO_GROUPING = 'NoGrouping';
export const EDITABLE_TABLE = 'EditableTable';
export const TEXT = 'Text';
export const DETACH_TITLE_MODE = 'detachTitle';
export const DELETE_SECTION_MODE = 'deleteSection';
export const DEFAULT_PERIOD = 'Default period';
export const SORT_STORAGE_KEY = 'dashboard_sort_preferences';
export const RAPID_ACTIONS = {
  ANALYTICS: 'Start analytics',
  ORG_CHART: 'Explore your organization',
  PEOPLE: 'Access all employees',
  COMPLIANCE: 'Check compliance',
};
export const BDESEHeadcountBreakPoint = 300;
export const INDEX_MW = 'IndexMW';
export const BDESE_TYPE_PREFIX = 'BDESE';
export const PAYROLL_FORECAST_TYPE_PREFIX = 'PayrollForecast';

export const FULL_DATA_ACCESS_MODULES = [BDESE_TYPE_PREFIX, PAYROLL_FORECAST_TYPE_PREFIX];

export function hasFullDataAccessModule(moduleAccess = []) {
  return FULL_DATA_ACCESS_MODULES.some((module) => moduleAccess?.includes(module));
}

export const POPULATION_OPTION_TYPES = {
  COMPANY: 'company',
  ENTITY: 'entity',
  DEPARTMENT: 'department',
  SELECT_ALL: 'select-all',
};

export const REPORT_STATUSES = {
  DRAFT: 'Draft',
  COMPLETED: 'Completed',
  PUBLISHED: 'Published',
};

export const VERSION_TYPES = {
  LIVE: 'live',
  FROZEN: 'frozen',
  PUBLISHED: 'published',
};

export const REPORT_ERROR_CODES = {
  SHARED_FROZEN_CANNOT_DELETE: 'Cannot delete a shared frozen version.',
};

export const XAXIS = {
  MONTHS: 'Months',
  EMPLOYEE_AGE: 'EmployeeAge',
};

export const GROUP_BY_OPTIONS = {
  GENDER: 'Gender',
};

export const METRIC_OPTIONS = {
  WORKFORCE: 'Workforce',
  TOTAL: 'Total',
  RECRUITMENT: 'Recruitment',
  RECRUITMENT_PIPELINE: 'RecruitmentPipeline',
  COMPENSATION: 'Compensation',
  GROSS_SALARY: 'GrossSalary',
  BASE_SALARY: 'BaseSalary',
};

export const euroMetrics = [
  'AverageSalary',
  'GrossSalary',
  'TotalChargedSalary',
  'AverageNetSalary',
  'MedianNetSalary',
  'MedianSalary',
  'MaxNetSalary',
  'MaxSalary',
  'MinNetSalary',
  'MinSalary',
  'Q1NetSalary',
  'Q1Salary',
  'Q3NetSalary',
  'Q3Salary',
  'NetSalary',
  'AnnualChangeSalary',
  'GapGenderAbsoluteGrossSalary',
  'AverageCumulativeSalary',
  'AverageTrainingCostPerEmployee',
  'AverageTrainingSalaryCostPerEmployee',
  'AverageTotalTrainingCostPerEmployee',
  'AverageTrainingCostPerTrainee',
  'AverageTrainingSalaryCostPerTrainee',
  'AverageTotalTrainingCostPerTrainee',
  'AverageHourlyWage',
  'TrainingCost',
  'TrainingSalaryCost',
  'TotalTrainingCost',
  'GrossSalaryPerFTE',
  'ChargedSalaryPerFTE',
  'NetSalaryPerFTE',
  'TotalAmount',
];

export const percentageMetrics = [
  'TurnoverRate',
  'AttritionRate',
  'AttritionRateVoluntary',
  'TurnoverRateVoluntary',
  'AnnualChangeRateSalary',
  'GapGenderRateGrossSalary',
  'AbsenteeismRateTraining',
  'ManagerRatio',
  'AbsenteeismRate',
  'CancelSessionsRate',
  'RateOfTrainees',
  'FailedHiresRatio3Months',
  'FailedHiresRatio6Months',
  'FailedHiresRatio12Months',
  'FemaleRate',
  'RetentionRate',
  'Attrition Rate',
  'Turnover Rate',
  'Absenteeism Rate',
];

export const timeMetrics = ['Age average', 'AverageTenure', 'TimeToHire', 'TotalAbsenceDays'];
export const officialColorsName = 'officialColors';

export const legalHubReportStatusOptions = [
  'all',
  REPORT_STATUSES.DRAFT,
  REPORT_STATUSES.COMPLETED,
  REPORT_STATUSES.PUBLISHED,
];

export const legalHubReportTypeOptions = ['all', BDESE_TYPE_PREFIX, INDEX_MW];

export const CHART_DATA_TYPES = {
  METRIC: 'metric',
  CATEGORICAL: 'categorical',
  SERIES: 'series',
  GENERIC: 'generic',
};

export const LANGUAGES = {
  ENGLISH: 'english',
  FRENCH: 'french',
};

export const LANGUAGE_CODES = {
  EN: 'EN',
  FR: 'FR',
  EN_US: 'EN_US',
  FR_FR: 'FR_FR',
};

export const LANGUAGE_MAP = {
  [LANGUAGE_CODES.EN]: LANGUAGES.ENGLISH,
  [LANGUAGE_CODES.FR]: LANGUAGES.FRENCH,
  [LANGUAGE_CODES.EN_US]: LANGUAGES.ENGLISH,
  [LANGUAGE_CODES.FR_FR]: LANGUAGES.FRENCH,
};

export const FALLBACK_STRINGS = {
  UNTITLED_GRAPH: 'Untitled Graph',
  UNKNOWN: 'Unknown',
  NOT_AVAILABLE: 'N/A',
};

export const BDESE_DOCUMENT_LAYOUT = {
  BASE_PADDING: 6,
  LEVEL_MULTIPLIER: 8,
};

export const COMMENT_STATUSES = {
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
};
export const SCROLL_OFFSET_PX = 20;
export const HIGHLIGHT_DURATION_MS = 2000;
export const SCROLL_RETRY_DELAY_MS = 150;

export const REPORT_CHART_TYPES = new Set([
  CHART_TYPES.METRIC,
  CHART_TYPES.DONUT,
  CHART_TYPES.PIE,
  CHART_TYPES.LINE,
  CHART_TYPES.BAR,
  CHART_TYPES.STACK_BAR,
  CHART_TYPES.HORIZONTAL_STACK_BAR,
  CHART_TYPES.BUBBLE,
  CHART_TYPES.SCATTER,
  CHART_TYPES.PYRAMID,
  CHART_TYPES.DATA_GRID,
]);

export const INSIGHT_STATUS_DELETED = 'DELETED';

export const DATE_RANGES = {
  CUSTOM: 'Custom',
};

export const COMPARISON_VALUES = {
  PREVIOUS_YEAR: 'Previous year',
};
